import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/productService";

export const fetchProducts = createAsyncThunk("products/fetchAll", async (params) => {
  const res = await svc.getProducts(params);
  return res.data;
});

export const createProductThunk = createAsyncThunk("products/create", async (data) => {
  const res = await svc.createProduct(data);
  return res.data;
});

export const updateProductThunk = createAsyncThunk("products/update", async ({ id, data }) => {
  const res = await svc.updateProduct(id, data);
  return res.data;
});

export const deleteProductThunk = createAsyncThunk("products/delete", async (id) => {
  await svc.deleteProduct(id);
  return id;
});

const productSlice = createSlice({
  name: "products",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchProducts.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchProducts.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createProductThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateProductThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((p) => p.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteProductThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((p) => p.id !== action.payload);
      });
  },
});

export default productSlice.reducer;
